import { mapSituationToApi, mapTypeToApi } from "./status";
export var HEARING_PAGE_SIZE = 50;
var closedStatuses = [
    "awaiting_recording",
    "awaiting_minutes",
    "finished",
];
export var buildHearingApiFilters = function (filters, page, limit) {
    if (page === void 0) { page = 0; }
    if (limit === void 0) { limit = HEARING_PAGE_SIZE; }
    var apiFilters = {
        direction: "DESC",
        limit: limit,
        page: page,
    };
    var title = filters.search.trim();
    if (title) {
        apiFilters.title = title;
    }
    var type = mapTypeToApi(filters.modality);
    if (type) {
        apiFilters.type = type;
    }
    var situation = mapSituationToApi(filters.situation);
    if (situation === "in_progress") {
        apiFilters.status = "available";
    }
    if (typeof filters.agencyId === "number") {
        apiFilters.agencyId = filters.agencyId;
    }
    if (typeof filters.themeId === "number") {
        apiFilters.themeId = filters.themeId;
    }
    return apiFilters;
};
export var matchesHearingClientFilters = function (hearing, filters, period) {
    var type = mapTypeToApi(filters.modality);
    if (type && hearing.type !== type) {
        return false;
    }
    if (filters.situation === "Em andamento" && hearing.status !== "available") {
        return false;
    }
    if (filters.situation === "Encerrada" &&
        !closedStatuses.includes(hearing.status)) {
        return false;
    }
    if (typeof filters.agencyId === "number" &&
        hearing.agencyId !== filters.agencyId) {
        return false;
    }
    if (typeof filters.themeId === "number" &&
        hearing.themeId !== filters.themeId) {
        return false;
    }
    var search = filters.search.trim().toLowerCase();
    if (search &&
        !hearing.title.toLowerCase().includes(search) &&
        !hearing.description.toLowerCase().includes(search)) {
        return false;
    }
    if (period === null || period === void 0 ? void 0 : period.scheduledFrom) {
        var fromTime = new Date(period.scheduledFrom).getTime();
        var hearingTime = new Date(hearing.startDate).getTime();
        if (Number.isFinite(fromTime) && hearingTime < fromTime) {
            return false;
        }
    }
    if (period === null || period === void 0 ? void 0 : period.scheduledTo) {
        var toTime = new Date(period.scheduledTo).getTime();
        var hearingTime = new Date(hearing.startDate).getTime();
        if (Number.isFinite(toTime) && hearingTime > toTime) {
            return false;
        }
    }
    return true;
};
